import Service from './Service';

export default class OfferEvaluations extends Service {

  insertEvaluation({ action, offer }) {
    return this.axiosInstance.post(`/offers_evaluations/like_or_deslike`, { action: action, offer: offer });
  }

}
